module.exports = __webpack_public_path__ + "img/404.5e78e67c.jpg";